import { css } from 'styled-components';
import { hideScroll } from 'styled-manila';
import { StyleVars, typeScale, getNumFromPx } from 'core/utils';

export const makePercent = (num, base) => `${(num / base) * 100}%`;

export const flexCols = (num, base) => css`
	max-width: ${makePercent(num, base)};
	flex-basis: ${makePercent(num, base)};
`;

export const round = num => Math.round(num * 100) / 100;

// TODO: there is also a `baseText` core/styles...
export const normalText = css`
	font-size: 16px;
	line-height: 17px;
	letter-spacing: 0.2px;
`;

export const horizontalOverflowItem = css`
	display: flex;
	flex-direction: column;
	text-decoration: none;
	padding: 0 12px;
	max-width: ${makePercent(1,3)};
	flex-basis: ${makePercent(1,3)};

	@media(max-width: 1023px) {
		width: 267px;
		flex-basis: 267px;
		max-width: 267px;
		min-width: 267px;
		margin-bottom: 0;

		/* Show the last gap to the right */
		&:last-child {
			position: relative;
			&:after {
				content: '';
				width: 32px;
				height: 100%;
				display: block;
				position: absolute;
				top: 0;
				right: -32px;
			}
		}
	}
`;

/**
 * aka mobile horizontal scroll all the things!
 *
 * @returns {CSS String}
 */
export const horizontalOverflowParent = css`
	display: flex;
	flex-wrap: wrap;
	margin-left: -12px;
	margin-right: -12px;

	@media(max-width: ${props => props.wrapAt || 1023}px) {
		margin: 24px -16px 0;
		flex-wrap: nowrap;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		padding-left: 25px;

		${hideScroll};
	}
`;

const maxContainerWidth = (maxWidth) => {
	// e.g. "1920px + 64px"
	maxWidth = maxWidth || StyleVars.screenCjDesktopXxl;
	maxWidth = getNumFromPx(maxWidth) + (StyleVars.defaultSpacingUnit * 4);
	return `${maxWidth}px`;
};

// Usage: ${maxContainer(StyleVars.screenCjDesktopLg)}
export const maxContainer = (maxWidth) => css`
	max-width: ${maxWidth || StyleVars.screenCjDesktopXxl};
	margin-left: ${typeScale(2)};
	margin-right: ${typeScale(2)};

	@media (min-width: ${StyleVars.screenSm}) {
		margin-left: ${typeScale(4)};
		margin-right: ${typeScale(4)};
	}

	@media (min-width: ${maxContainerWidth(maxWidth)}) {
		margin-left: auto;
		margin-right: auto;
	}
`;

/*---CSS GRID MIXINS---
	You don't need to use these
	unless you're trying to support IE11 (mission-critical like listing results)
	want grid-template-areas & grid-gap?
	> GFL: https://medium.com/@elad/supporting-css-grid-in-internet-explorer-b38669e75d66
	> See also: https://stackoverflow.com/a/46745140
	--------------------------*/
export const grid = (rows='1fr', cols='1fr') => css`
	/* stylelint-disable value-no-vendor-prefix */
	display: -ms-grid;
	/* stylelint-enable */
	display: grid;
	${gridTemplateCols(cols)}
	${gridTemplateRows(rows)}
`;

export const gridTemplateCols = (cols='1fr') => css`
	/* stylelint-disable property-no-vendor-prefix */
	-ms-grid-columns: ${cols};
	/* stylelint-enable */
	grid-template-columns: ${cols};
`;

export const gridTemplateRows = (rows='1fr') => css`
	/* stylelint-disable property-no-vendor-prefix */
	-ms-grid-rows: ${rows};
	/* stylelint-enable */
	grid-template-rows: ${rows};
`;
